import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const AddChannelModalBody = styled(Modal.Body)`
    .radio-container {
        display: grid;
        grid-template-areas: 'L L' 'A M';
        grid-template-columns: min-content 1fr;
        gap: 8px;
        > label {
            grid-area: L;
        }
        > .radio {
            &:first-child {
                grid-area: A;
            }
            &:last-child {
                grid-area: M;
            }

            label {
                white-space: nowrap;
            }
        }
    }

    #channelsList-createModal-field-id {
        &:disabled {
            /* background: var(--gray-100);
            border-color: var(--gray-300); */
            opacity: 0.5;
            border-color: var(--gray-500);
        }
    }
`
